import React, {Component} from 'react'
import {Button, Drawer, Form} from 'antd';
import Swal from "sweetalert2";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {withTourGuide} from "../../guideComponent/withTourGuide";

class EditUser extends Component {
    constructor() {
        super();
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
    }
    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        showGuide(target, config);
    };

    handleEdit = () => {
        let form = {
            p_user_id: this.props.data.p_user_id,
            p_user_name: this.props.data.p_user_name,
            p_user_email: this.props.data.p_user_email,
            p_user_wa: this.props.data.p_user_wa,
            p_user_level: this.props.data.p_user_level,
        }
        this.props.request("edit_user", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        p_user_name : ''
                    },() =>this.props.changeState({
                        visable: false,
                        p_user_name : '',
                        data: [],
                        isLoading: true,
                    },() => {
                        this.props.loadData()
                    }))
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                }
                if (response.failed) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
            });
    }


    render() {
        return (
            <Modal size="lg"  zIndex={999} toggle={() => {
                this.props.changeState({visable: false, p_user_name:''});
            }} isOpen={this.props.data.visable}>
                <ModalHeader>Edit User</ModalHeader>
                <ModalBody>
                    <div className="">
                        <Form layout="vertical" hideRequiredMark>
                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "guideEditNamaUser",
                                        title: "Nama User",
                                        content: "Masukkan atau ubah nama lengkap user sesuai data akun yang digunakan."
                                    });
                                }}
                            >
                                <label>Nama User</label>
                                <input
                                    name="p_user_name"
                                    className="form-control col-xl-12 col-md-12"
                                    placeholder="Nama User..."
                                    type="text"
                                    required=""
                                    value={this.props.data.p_user_name}
                                    onChange={(event) => {
                                        const target = event.target;
                                        const value = target.value;
                                        const name = target.name;
                                        this.props.changeState({
                                            [name]: value
                                        });
                                    }}
                                />
                            </div>
                        </Form>

                        <Form layout="vertical" hideRequiredMark>
                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "guideEditEmailUser",
                                        title: "Email User",
                                        content: "Masukkan atau ubah email aktif user. Email ini dapat digunakan untuk login atau kebutuhan notifikasi sistem."
                                    });
                                }}
                            >
                                <label>Nama Email</label>
                                <input
                                    name="p_user_email"
                                    className="form-control col-xl-12 col-md-12"
                                    placeholder="Email User..."
                                    type="text"
                                    required=""
                                    value={this.props.data.p_user_email}
                                    onChange={(event) => {
                                        const target = event.target;
                                        const value = target.value;
                                        const name = target.name;
                                        this.props.changeState({
                                            [name]: value
                                        });
                                    }}
                                />
                            </div>
                        </Form>

                        <Form layout="vertical" hideRequiredMark>
                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "guideEditWaUser",
                                        title: "No. WA User",
                                        content: "Masukkan atau ubah nomor WhatsApp user jika tersedia. Field ini bersifat opsional."
                                    });
                                }}
                            >
                                <label>No. WA User (Opsional)</label>
                                <input
                                    name="p_user_wa"
                                    className="form-control col-xl-12 col-md-12"
                                    placeholder="No. WA User..."
                                    type="text"
                                    required=""
                                    value={this.props.data.p_user_wa}
                                    onChange={(event) => {
                                        const target = event.target;
                                        const value = target.value;
                                        const name = target.name;
                                        this.props.changeState({
                                            [name]: value
                                        });
                                    }}
                                />
                            </div>
                        </Form>

                        <Form layout="vertical" hideRequiredMark>
                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "guideEditLevelUser",
                                        title: "Level User",
                                        content: "Pilih atau ubah level user sesuai hak akses dan peran user di dalam sistem."
                                    });
                                }}
                            >
                                <label>Level User</label>
                                <select
                                    name="p_user_level"
                                    className="form-control col-xl-12 col-md-12"
                                    value={this.props.data.p_user_level}
                                    onChange={(event) => {
                                        const target = event.target;
                                        const value = target.value;
                                        const name = target.name;
                                        this.props.changeState({
                                            [name]: value
                                        });
                                    }}
                                >
                                    <option value="">Pilih Level User</option>
                                    {this.props.data.dataLevel && this.props.data.dataLevel.map((item, index) => {
                                        return (
                                            <option key={item.level_id || index} value={item.level_id}>
                                                {item.level_name}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </Form>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onChange={() => {
                            this.props.changeState({visable: false, p_user_name: ''});
                        }}
                                style={{marginRight: 8}}>
                            Batal
                        </Button>
                        <Button onClick={this.handleEdit} type="primary">
                            Simpan
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default withTourGuide(EditUser)
